import { Condition } from '@types';

export const groupConditionsByFieldAndOperator = (data: Condition[]): Record<string, Record<string, string[]>> => {
  const groupedConditions: Record<string, Record<string, string[]>> = {};

  data.forEach((condition) => {
    const field = condition.field ?? 'N/A';
    const operator = condition.operator ?? 'N/A';
    const values = condition.values?.map((value) => value.value) ?? [];

    if (!groupedConditions[field]) {
      groupedConditions[field] = {};
    }

    if (!groupedConditions[field][operator]) {
      groupedConditions[field][operator] = [];
    }

    groupedConditions[field][operator].push(...values);
  });

  return groupedConditions;
};
